import React, { Component } from 'react';
import './Profile.css';
import NabarClient from '../Components/NabarClient/NabarClient';
import HeaderTool from '../Components/HeaderTool/HeaderTool';
import personlg from '../../../image/personlg.svg'
import iconpen from '../../../image/iconpen.svg'
import closeicon from '../../../image/closeicon.svg'
import HandleRes from '../Components/HandleRes/HandleRes';
import MapsNewOrder from '../../Components/Maps/MapsNewOrder';
import { LinkAPI } from '../../../API/API'
import searchbule from '../../../image/searchbule.svg';
import axios from 'axios'
import { Link } from 'react-router-dom';

class Profile extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            name: "",
            email: "",
            phone: "",
            oldphone:"",
            usecompanyinfo: "",
            password: "",
            Newpassword: "",
            numberoforders: "",
            companyname: "",
            companycity: "",
            address_name: "",
            address_alias: "",
            coordinates: [],
            ZipCode: "",
            CompanyPhone:Number,            
            code: "",
            nameError: "",
            emailError: "",
            phoneError: "",
            passwordError: "",
            NewpasswordError: "",
            address_nameError: "",
            address_aliasError: "",
            ZipCodeError: "",
            CompanyPhoneError: "",
            address_aliasError: "",
            companycityError: "",
            companynameError: "",
            codeError: "",
            Verify: false,
            res_doneEdit: false,
            res_doneChangeEmail: false,
            res_doneChangepassword: false,
            res_doneChangephone: false,
            networkError: false,
            errordatamessage: false,
            errordatamessagetext: '',
            errordataEmailmessage: false,
            errordatamessageEmailtext: '',
            hasError: false,
        }
        this.getinfo()
    }
    getinfo = () => {
        const Token = localStorage.getItem("userToken")

        axios.get(`${LinkAPI}/api/businessowner/getinfo`, {
            headers: {
                Authorization: `${Token}`,
                lang:"ar"
            }
        }).then(res => {
            this.setState({
                data: res.data.businessOwner
            })
            this.setState({
                name: res.data.businessOwner.name,
                email: res.data.businessOwner.email,
                phone: res.data.businessOwner.phone.replace(/^20+/, ''),                
                oldphone: res.data.businessOwner.phone.replace(/^20+/, ''),
                name: res.data.businessOwner.name,
                usecompanyinfo: res.data.businessOwner.usecompanyinfo,
                numberoforders: res.data.businessOwner.numberoforders,
                companyname: res.data.businessOwner.companyinfo.companyname,
                companycity: res.data.businessOwner.companyinfo.companycity,
                ZipCode: res.data.businessOwner.companyinfo.companyzipcode,
                CompanyPhone:res.data.businessOwner.companyinfo.phone.replace(/^20+/, ''),
                address_name: res.data.businessOwner.companyinfo.address.address_name,
                address_alias: res.data.businessOwner.companyinfo.address.address_alias,
                coordinates: res.data.businessOwner.companyinfo.address.location.coordinates,
                nameError: "",
                emailError: "",
                phoneError: "",
                passwordError: "",
                NewpasswordError: "",
                address_nameError: "",
                address_aliasError: "",
                ZipCodeError: "",
                codeError: "",
                Verify: false,
                res_doneEdit: false,
                res_doneChangeEmail: false,
                res_doneChangepassword: false,
                res_doneChangephone: false,
                networkError: false,
                errordatamessage: false,
                errordatamessagetext: '',
                errordataEmailmessage: false,
                errordatamessageEmailtext: '',
                hasError: false,
            })
        }).catch(error => {
            this.HandleError(error)
        })
    }

    HandleError = (error) => {
        if (!error.response) {
            this.setState({
                networkError: true
            })
        } else if (error.response.status === 402) {
            localStorage.removeItem("userToken")
            window.location.replace("/AR/SignIn");
        } else if (error.response.data.message) {
            this.setState({
                errordatamessage: true,
                errordatamessagetext: error.response.data.message
            })
        } else {
            this.setState({
                hasError: true,
            })
        }
    }
    handleChange = event => {
        const isCheckbox = event.target.type === "checkbox";
        this.setState({
            [event.target.name]: isCheckbox
                ? event.target.checked
                : event.target.value
        });
    };
    resetsomvar=()=>{
        this.setState({
            password: "",
            Newpassword: "",
            code: "",

        })
    }
    setStatecoordinatesaddress_alias = (coordinates, address_name) => {
        this.setState({
            coordinates: coordinates,
            address_name: address_name

        })

    }
    validateinfo = () => {
        let nameError = "";
        let ZipCodeError = "";
        let CompanyPhoneError="";
        let address_nameError="";
        let address_aliasError="";
        let companycityError="";
        let companynameError="";
        if (!isNaN(this.state.address_name)) {
            address_nameError = "اختار عنوان صحيحا";
        }
        
        if (this.state.name.length < 2 || !isNaN(this.state.name)) {
            nameError = "ادخل الاسم صحيح";
        }

   
        if (this.state.companyname.length < 2 || !isNaN(this.state.companyname)) {
            companynameError = "اكتب اسم الشركه صحيح";
        }
        if (this.state.companycity.length < 2 || !isNaN(this.state.companycity)) {
            companycityError = "اكتب اسم المدينه صحيح";
        }
        if (this.state.ZipCode.length!==5 ||  isNaN(this.state.ZipCode)) {
            ZipCodeError = "رقم البريد";
        }
        
        if (isNaN(this.state.CompanyPhone) || this.state.CompanyPhone.length < 10 ||this.state.CompanyPhone.length >11) {
            CompanyPhoneError = "اكتب رقم الهاتف صحيح ";
        }
        if (this.state.address_name.length < 5 || !isNaN(this.state.address_name)) {
            address_nameError = "اختار عنوان صحيحا";
        }
        if (this.state.address_alias.length < 5 || !isNaN(this.state.address_alias)) {
            address_aliasError = "اكتب تفاصيل العنوان صحيحا";
        }
        if (!this.state.coordinates) {
            address_nameError = "اختار عنوان صحيحا";
        }



        if (nameError ||companynameError||companycityError|| ZipCodeError||address_nameError||address_aliasError ||CompanyPhoneError) {
            this.setState({ nameError,companynameError, companycityError,ZipCodeError, address_nameError,CompanyPhoneError,address_aliasError });
            return false;
        }

        return true;
    };
    validateemail = () => {
        let emailError = "";
        let passwordError = "";
        if (!this.state.email.includes("@")) {
            emailError = "ادخل البريد الالكتروني صحيح ";
        }


        if (this.state.password.length < 8) {
            passwordError = "الرقم السري غير صحيح";
        }


        if (emailError || passwordError) {
            this.setState({ emailError, passwordError });
            return false;
        }

        return true;
    };
    validatephone = () => {
        let phoneError = "";
        let passwordError = "";
        if (isNaN(this.state.phone) || this.state.phone.length < 10) {
            phoneError = "ادخل رقم الهاتف صحيح ";
        }
        if (this.state.password.length < 8) {
            passwordError = "الرقم السري غير صحيح";
        }


        if (phoneError || passwordError) {
            this.setState({ phoneError, passwordError });
            return false;
        }

        return true;
    };
    validatepassword = () => {
        let passwordError = "";
        let NewpasswordError = "";
        if (this.state.password.length < 8) {
            passwordError = "الرقم السري غير صحيح يجب ان لا يقل عن 8 حروف او ارقام";
        }

        if (this.state.Newpassword.length < 8) {
            NewpasswordError ="الرقم السري غير صحيح يجب ان لا يقل عن 8 حروف او ارقام";
        }

        if (passwordError || NewpasswordError) {
            this.setState({ passwordError, NewpasswordError });
            return false;
        }

        return true;
    };
    validateVerify = () => {
        let codeError = "";

        if (this.state.code.length !== 4 || isNaN(this.state.code)) {
            codeError = "ادخل الرمز المرسول اليك في الرساله علي رقم الهاتف";
        }
        if (codeError) {
            this.setState({ codeError });
            return false;
        }
        return true;
    };
    handleSubmitEditinfo = event => {
        event.preventDefault();
        const Token = localStorage.getItem("userToken")
        const { name, usecompanyinfo, companyname,CompanyPhone, companycity, address_name, address_alias, coordinates, ZipCode } = this.state
        const isValid = this.validateinfo();
        if (isValid) {
            axios.put(`${LinkAPI}/api/businessowner/editinfo`, {
                name: name,
                usecompanyinfo: usecompanyinfo,
                companyinfo: {
                    companyname: companyname,
                    companycity: companycity,
                    companyzipcode: ZipCode,
                    phone:20+CompanyPhone.replace(/^0+/, ''),

                    address: {
                        address_name: address_name,
                        address_alias: address_alias,
                        location: {
                            type: "point",
                            coordinates: coordinates
                        }
                    }
                }
            }, {
                headers: {
                    Authorization: `${Token}`,
                    lang:"ar"
                }
            }).then(res => {
                this.setState({
                    nameError: "",
                    ZipCodeError: "",
                    CompanyPhoneError: "",
             address_aliasError: "",
             companycityError: "",
             companynameError: "",
                    res_doneEdit: true,
                    networkError: false,
                    errordatamessage: false,
                    errordatamessagetext: '',
                    hasError: false,
                })
                setTimeout(() => {
                    this.setState({
                        res_doneEdit: false
                    })
                }, 2000);
            })
                .catch(error => {
                    this.HandleError(error)
                })


        }
    };
    handleSubmitemail = event => {
        event.preventDefault();
        const { email, password } = this.state
        const isValid = this.validateemail();
        if (isValid) {
            const Token = localStorage.getItem("userToken")
            axios.put(`${LinkAPI}/api/businessowner/changeemail`, { email: email, password: password }, {
                headers: {
                    Authorization: `${Token}`,
                    lang:"ar"
                }
            }).then(res => {
                localStorage.setItem("userToken", res.data.token)
                this.setState({
                    emailError: "",
                    passwordError: "",
                    res_doneChangeEmail: true,
                    networkError: false,
                    errordatamessage: false,
                    errordatamessagetext: '',
                    errordataEmailmessage: false,
                    hasError: false,
                    emailError: "",
                        passwordError: "",
                })
                setTimeout(() => {
                    this.setState({
                        res_doneChangeEmail: false,
                        
                    })
                }, 15000);
            })
                .catch(error => {
                    if (!error.response) {
                        this.setState({
                            networkError: true
                        })
                    } else if (error.response.status === 402) {
    
                        window.location.replace("/AR/SignIn");
                    } else if (error.response.data.message) {
                        this.setState({
                            emailError: "",
                            passwordError: "",
                            errordataEmailmessage: true,
                            errordatamessageEmailtext: error.response.data.message
                        })
                    } else {
                        this.setState({
                            hasError: true,
                        })
                    }
                })
        }
    };
    handleSubmitphone = event => {
        event.preventDefault();
        const { phone, password } = this.state
        const Token = localStorage.getItem("userToken")
        const isValid = this.validatephone();
        if (isValid) {
            axios.put(`${LinkAPI}/api/businessowner/changephone`, {phone:20+phone.replace(/^0+/, ''), password }, {
                headers: {
                    Authorization: `${Token}`,
                    lang:"ar"
                }
            }).then(res => {
                this.setState({
                    Verify: true,
                    errordataPhonemessage: false,
                    errordatamessage: false,
                    phoneError: "",
                    passwordError: "",
                })
                localStorage.setItem("userToken", res.data.token)

            }).catch(error => {
                if (!error.response) {
                    this.setState({
                        networkError: true,
                    })
                } else if (error.response.status === 402) {
                    window.location.replace("/AR/SignIn");
                } else if (error.response.data.message) {
                    this.setState({
                        phoneError: "",
                        passwordError: "",
                        errordataPhonemessage: true,
                        errordatamessagePhonetext: error.response.data.message
                    })
                } else {
                    this.setState({
                        hasError: true,
                    })
                }
            })

        }
    };
    handleSubmitVerify = event => {
        event.preventDefault();
        const { code } = this.state
        const Token = localStorage.getItem("userToken")
        const isValid = this.validateVerify();
        if (isValid) {
            axios.post(`${LinkAPI}/api/businessowner/confirmchangephone`, { code }, {
                headers: {
                    Authorization: `${Token}`,
                    lang:"ar"
                }
            }).then(res => {
                this.setState({
                    Verify: false,
                    res_doneChangephone: true,
                    networkError: false,
                    errordataPhoneVerifymessage: false,
                    errordatamessage: false,
                    errordatamessagetext: '',
                    hasError: false,
                })
                localStorage.setItem("userToken", res.data.token)
                setTimeout(() => {
                    this.setState({
                        res_doneChangephone: false
                    })
                }, 2000);

            }).catch(error => {
                if (!error.response) {
                    this.setState({
                        networkError: true,
                    })
                } else if (error.response.status === 402) {
                    window.location.replace("/SignIn");
                } else if (error.response.data.message) {
                    this.setState({
                        codeError: "",
                        errordataPhoneVerifymessage: true,
                        errordatamessagePhoneVerifytext: error.response.data.message
                    })
                } else {
                    this.setState({
                        hasError: true,
                    })
                }
            })
        }
    };
    handleSubmitChangepassword = event => {
        event.preventDefault();
        const { password, Newpassword } = this.state
        const Token = localStorage.getItem("userToken")
        const isValid = this.validatepassword();
        if (isValid) {
            axios.put(`${LinkAPI}/api/businessowner/changepassword`, { oldpassword: password, newpassword: Newpassword }, {
                headers: {
                    Authorization: `${Token}`,
                    lang:"ar"
                }
            }).then(res => {
                this.setState({
                    networkError: false,
                    errordatamessage: false,
                    errordatamessagetext: '',
                    hasError: false,
                    res_doneChangepassword: true,
                    passwordError: "",
                    NewpasswordError: "",
                    errordatapasswordmessage: false,

                })
                setTimeout(() => {
                    this.setState({
                        res_doneChangepassword: false,
                    })
                }, 2000);
            }).catch(error => {
                if (!error.response) {
                    this.setState({
                        networkError: true,
                    })
                } else if (error.response.status === 402) {
                    window.location.replace("/SignIn");
                } else if (error.response.data.message) {
                    this.setState({
                        passwordError: "",
                        NewpasswordError: "",
                        errordatapasswordmessage: true,
                        errordatamessagepasswordtext: error.response.data.message
                    })
                } else {
                    this.setState({
                        hasError: true,
                    })
                }
            })

        }
    };
    render() {
        const { name, usecompanyinfo, email, phone, password, Newpassword, ZipCode, numberoforders, companyname, companycity,CompanyPhone, address_name, address_alias } = this.state
        document.title ="kayn | الصفحة الشخصيه "; 
        document.getElementsByTagName("META")[1].content="كاين | الصفحة الشخصيه ";
        document.documentElement.lang = 'ar';
        return (
            <div>


                <div className="AppAR row  mx-0">
                    <div className="col-md-1 px-0 ">
                        <NabarClient />
                    </div>
                    <div className="  client profile col-md-11 px-lg-5">
                        <HeaderTool />
                        <div className="shadow p-lg-5 p-3 m-1 bg-white ">
                            <p className="col-12 mt-2 p-0 fontsize10  ">
                                <img className="ml-3 iconsm" src={personlg} alt="user kayn" />
                                {name}
                            </p>
                            <p className="fontsize12 mx-5">عدد الطلابات: {numberoforders}</p>
                            <p className="col-12 mt-2 p-0 fontsize4 font-weight-bold ">التفاصيل الشخصيه</p>
                            <hr />
                            <div className="form-row">
                                <div className="col-md-4 col-sm-6  px-2">
                                    <label className="text-muted fontsize12">الاسم الشخصي</label>
                                    <input type="text" className={"form-control badge-pill p-3 " + (this.state.nameError ? 'is-invalid' : '')} placeholder="الاسم الشخصي" name="name" value={name} onChange={this.handleChange} />
                                    <div style={{ fontSize: 12, color: "red" }}>
                                        {this.state.nameError}
                                    </div>
                                </div>
                                <div className="col-md-4 col-sm-6 mx-4 my-1 p-4">
                                    <input className="form-check-input" type="checkbox" id="gridCheck" name="usecompanyinfo" value={usecompanyinfo} onChange={this.handleChange} checked={(this.state.usecompanyinfo ? 'checked' : '')} />
                                    <label className="form-check-label fontsize11" htmlFor="gridCheck"  >
                                        استخدتم بيانات الشركه للتوصيل
                                </label>
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="col-md-4 col-sm-6 px-2">
                                    <label className="text-muted fontsize12">اسم الشركه</label>
                                    <input type="text" className={"form-control badge-pill p-3 " + (this.state.companynameError ? 'is-invalid' : '')} placeholder="اسم الشركه" name="companyname" value={companyname} onChange={this.handleChange} />
                                    <div style={{ fontSize: 12, color: "red" }}>
                                                        {this.state.companynameError}
                                    </div>
                                </div>
                                <div className="col-md-4 col-sm-6 px-2">
                                    <label className="text-muted fontsize12">محافظة الشركه</label>
                                    <input type="text" className={"form-control badge-pill p-3 " + (this.state.companycityError ? 'is-invalid' : '')} placeholder="محافظة الشركه" name="companycity" value={companycity} onChange={this.handleChange} />
                                    <div style={{ fontSize: 12, color: "red" }}>
                                                        {this.state.companycityError}
                                    </div>
                                </div>
                                <div className="col-md-4 col-sm-6 px-2 counter">
                                    <label className="text-muted fontsize12">رقم البريد</label>
                                    <input type="number" className={"form-control badge-pill p-3 " + (this.state.ZipCodeError ? 'is-invalid' : '')} placeholder="رقم البريد" name="ZipCode" value={ZipCode} onChange={this.handleChange} />
                                    <div style={{ fontSize: 12, color: "red" }}>
                                        {this.state.ZipCodeError}
                                    </div>
                                </div>
                            </div>
                            <div className="form-row counter" >
                            <div className="col-md-4 col-sm-6 px-2">
                                    <label className="text-muted fontsize12">رقم هاتف الشركه</label>
                                    <div className="relative">
                                        <span className="codephone">+20</span>
                                    <input type="number" className={"form-control badge-pill pr-5 p-3  " + (this.state.CompanyPhoneError ? 'is-invalid' : '')} placeholder="رقم هاتف الشركه" name="CompanyPhone" value={CompanyPhone} onChange={this.handleChange} />
                                    
                                    </div>

                                    <div style={{ fontSize: 12, color: "red" }}>
                                        {this.state.CompanyPhoneError}
                                    </div>
                                </div>
                                <div className="col-md-6 col-sm-6 px-2">
                                    <MapsNewOrder key={this.state.data} state={this.state}   setStatecoordinatesaddress_alias={this.setStatecoordinatesaddress_alias} />
                                    <div className="col-md-12 px-3  px-lg-5">
                                        <label className="text-muted fontsize12">العنوان</label>
                                        <div className={"form-group pb-0 mb-1 relative search_div "  + (this.state.companynameError ? 'is-invalid' : '')} id="pac-container">
                                            <img className="ml-1 img_input" src={searchbule} alt="search" />
                                            <input type="text " id="pac-input" className={"px-5 search_input form-control badge-pill " + (this.state.address_nameError ? 'is-invalid' : '')} placeholder="العنوان" name="address_name" value={this.state.address_name} onChange={this.handleChange} />

                                        </div>
                                        <div style={{ fontSize: 12, color: "red" }} className="text-right">
                                            {this.state.address_nameError}
                                        </div>
                                        <div id="map"></div>
                                        <div className="form-group col-12 text-right mt-2">
                                            <label >تفاصيل العنوان</label>
                                            <input type="text" className={"form-control badge-pill p-3 " + (this.state.address_aliasError ? 'is-invalid' : '')} placeholder="تفاصيل العنوان" name="address_alias" value={this.state.address_alias} onChange={this.handleChange} />
                                            <div style={{ fontSize: 12, color: "red" }}>
                                                {this.state.address_aliasError}
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div className="text-center d-flex justify-content-around my-2 flex-wrap ">
                                <button onClick={this.handleSubmitEditinfo} type="submit" className="btn badge-pill p-2 pl-1 px-3 my-2 border shadow bg-white" ><img className="ml-1" src={iconpen} alt="pen" />حفظ التعديلات </button>
                                <button onClick={this.getinfo} className="btn badge-pill p-2 pl-1 px-3 my-2 border shadow bg-danger text-white " ><img className="ml-1 " src={closeicon} alt="iconclose" />الغاء </button>
                            </div>
                            <p className="col-6 mt-2 p-0 fontsize4 font-weight-bold ">الاعدادات</p>
                            <hr />
                            <div className="">
                                <div className="accordion" id="accordionExample">
                                    <div className="">
                                        <div className=" col-12 change row">
                                            <div className="col-md-4" id="headingOne">
                                                <h2 className="mb-0">
                                                    <button className="btn border shadow m-2" data-toggle="collapse" data-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne" onClick={this.resetsomvar}>
                                                        تغير البريد الالكتروني
                                            </button>
                                                </h2>
                                            </div>
                                            <div className="col-md-4" id="headingTwo">
                                                <h2 className="mb-0">
                                                    <button className="btn border shadow m-2" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo" onClick={this.resetsomvar}>
                                                        تغير رقم الهاتف
                                            </button>
                                                </h2>
                                            </div>
                                            <div className="col-md-4" id="headingThree">
                                                <h2 className="mb-0">
                                                    <button className="btn border shadow m-2" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree" onClick={this.resetsomvar}>
                                                        تغير الرقم السري
                                            </button>
                                                </h2>
                                            </div>
                                        </div>
                                        <div id="collapseOne" className="collapse " aria-labelledby="headingOne" data-parent="#accordionExample">
                                            <div className="border shadow p-3">
                                                    <div className="col-md-4 col-sm-6 px-2">
                                                        <label className="text-muted fontsize12"> البريد الالكتروني</label>
                                                        <input type="email" className="form-control  badge-pill" placeholder=" البريد الالكتروني" name="email" value={email} onChange={this.handleChange} />
                                                        <div style={{ fontSize: 12, color: "red" }}>
                                                            {this.state.emailError}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4 col-sm-6 px-2">
                                                        <label className="text-muted fontsize12">الرقم السري</label>
                                                        <input type="password" className="form-control  badge-pill" placeholder="الرقم السري" name="password" value={password} onChange={this.handleChange} />
                                                        <div style={{ fontSize: 12, color: "red" }}>
                                                            {this.state.passwordError}
                                                        </div>
                                                        {(this.state.errordataEmailmessage ?
                                                    <div className="px-2" style={{ fontSize: 12, color: "red" }}>
                                                        {this.state.errordatamessageEmailtext}
                                                    </div> : '')}
                                                    </div>
                                                    <div className="text-center d-flex justify-content-around my-2 flex-wrap ">
                                                        <button onClick={this.handleSubmitemail} className="btn badge-pill p-2 pl-1 px-3 my-2 border shadow bg-white" ><img className="ml-1" src={iconpen} alt="pen" />حفظ </button>
                                                        <button onClick={this.getinfo}  className="btn badge-pill p-2 pl-1 px-3 my-2 border shadow bg-danger text-white " ><img className="ml-1 " src={closeicon} alt="iconclose" />الغاء</button>
                                                    </div>
                                            </div>
                                        </div>
                                        <div id="collapseTwo" className="collapse " aria-labelledby="headingTwo" data-parent="#accordionExample">
                                            <div className="border shadow p-3 counter ">
                                                    <div className="col-md-4 px-2">
                                                        <label className="text-muted fontsize12">رقم الهاتف</label>
                                                        <div className="relative">
                                        <span className="codephone">+20</span>
                                  
                                                        <input type="number" className=" pr-5 form-control  badge-pill" placeholder="رقم الهاتف" name="phone" value={phone} onChange={this.handleChange} />
                                                        </div>

                                                       <div style={{ fontSize: 12, color: "red" }}>
                                                            {this.state.phoneError}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4 px-2">
                                                        <label className="text-muted fontsize12">الرقم السري</label>
                                                        <input type="password" className="form-control  badge-pill" placeholder="الرقم السري" name="phone" name="password" value={password} onChange={this.handleChange} />
                                                        <div style={{ fontSize: 12, color: "red" }}>
                                                            {this.state.passwordError}
                                                        </div>
                                                    </div>
                                                    {(this.state.errordataPhonemessage ?
                                                    <div className="px-2" style={{ fontSize: 12, color: "red" }}>
                                                        {this.state.errordatamessagePhonetext}
                                                    </div> : '')}
                                                    {(this.state.Verify ? ''
                                                    : (this.state.oldphone===phone?'':<div className="text-center d-flex justify-content-around my-2 flex-wrap ">
                                                        <button onClick={this.handleSubmitphone} type="submit" className="btn badge-pill p-2 pl-1 px-3 my-2 mx-auto border shadow bg-white" >Send Code</button>
                                                    </div>))}
                                                <div className="col-md-6">
                                                    {(this.state.Verify ?
                                                        <div className="" >
                                                        <div className="pt-5 pb-3 counter">
                                                                <div className=" px-lg-5">
                                                                    <label className="text-muted fontsize12">رمز التحقق من الهاتف</label>
                                     
                                                                    <input type="number" className={"form-control badge-pill col-md-8 p-3 " + (this.state.codeError ? 'is-invalid' : '')} placeholder="رمز التحقق من الهاتف " name="code" onChange={this.handleChange} value={this.state.code} />
                                                                </div>

                                                                <div style={{ fontSize: 12, color: "red" }}>
                                                                    {this.state.codeError}
                                                                </div>
                                                            </div>
                                                            {(this.state.errordataPhoneVerifymessage ?
                                                                    <div className="px-lg-5 py-1" style={{ fontSize: 12, color: "red" }}>
                                                                        {this.state.errordatamessagePhoneVerifytext}
                                                                    </div> : '')}
                                                                    <div className="text-center d-flex justify-content-around my-2 flex-wrap ">
                                                                <button onClick={this.handleSubmitVerify} type="submit" className="btn  badge-pill p-2 pl-1 px-3  border shadow btn-primary" >تاكيد</button>
                                                            </div>
                                                        </div>
                                                        :
                                                        ''
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                        <div id="collapseThree" className="collapse " aria-labelledby="headingThree" data-parent="#accordionExample">
                                            <div className="border shadow p-3">
                                                    <div className="col-md-4 col-sm-6 px-2">
                                                        <label className="text-muted fontsize12">الرقم السري الحالي</label>
                                                        <input type="password" className="form-control  badge-pill" placeholder="الرقم السري الحالي " name="password" value={password} onChange={this.handleChange} />
                                                        <div style={{ fontSize: 12, color: "red" }}>
                                                            {this.state.passwordError}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4 col-sm-6 px-2">
                                                        <label className="text-muted fontsize12">الرقم السري الجديد</label>
                                                        <input type="password" className="form-control  badge-pill" placeholder="الرقم السري الجديد" name="Newpassword" value={Newpassword} onChange={this.handleChange} />
                                                        <div style={{ fontSize: 12, color: "red" }}>
                                                            {this.state.NewpasswordError}
                                                        </div>
                                                    </div>
                                                    {(this.state.errordatapasswordmessage ?
                                                    <div className="px-2" style={{ fontSize: 12, color: "red" }}>
                                                        {this.state.errordatamessagepasswordtext}
                                                        <br/>
                                                        <Link to="/ForgetPassword"><span className="pointer fontsize11 text-muted py-1 my-1">Forget Password ?</span></Link>

                                                    </div> : '')}
                                                    <div className="text-center d-flex justify-content-around my-2 flex-wrap ">
                                                        <button onClick={this.handleSubmitChangepassword} className="btn badge-pill p-2 pl-1 px-3 my-2 border shadow bg-white" ><img className="ml-1" src={iconpen} alt="pen" />حفظ </button>
                                                        <button  onClick={this.getinfo} className="btn badge-pill p-2 pl-1 px-3 my-2 border shadow bg-danger text-white " ><img className="ml-1 " src={closeicon} alt="iconclose" />الغاء</button>
                                                    </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {(this.state.networkError ? <HandleRes title="تاكد باتصالك بالانترنت ثم عاود المحاوله" stylecss="alert-danger" /> : '')}
                {(this.state.res_doneEdit ? <HandleRes title=" تم تحديث المعومات الشخصيه" stylecss="alert-success" /> : '')}
                {(this.state.res_doneChangeEmail ? <HandleRes title=" تم ارسال رسالة تاكيد الي البريد الالكتروني" stylecss="alert-success" /> : '')}
                {(this.state.res_doneChangepassword ? <HandleRes title=" تم تغير الرقم السري" stylecss="alert-success" /> : '')}
                {(this.state.res_doneChangephone ? <HandleRes title=" تم تغير رقم الهاتف" stylecss="alert-success" /> : '')}
                {(this.state.errordatamessage ? <HandleRes title={this.state.errordatamessagetext} stylecss="alert-danger" /> : '')}
                {(this.state.hasError ? <HandleRes title="  هناك مشكلة في طلبك" stylecss="alert-danger" /> : '')}

            </div>
        )
    }
}
export default Profile;